import React, { useState } from "react";
import { TextInput } from "grommet";

const formatDisplay = (raw) => {
    const num = parseFloat(raw);
    if (raw === "" || raw === null || raw === undefined || isNaN(num))
        return "";
    return num.toLocaleString("en-AU", { style: "currency", currency: "AUD" });
};

// Controlled dollar-amount input. `value`/`onChange` always deal in the raw
// numeric string ("1234.5"), never the formatted one - formatting is purely
// a display concern, shown with a $ prefix while focused (for easy editing,
// no reformat-while-typing cursor jumps) and as "$1,234.50" once blurred.
const CurrencyInput = ({ value, onChange, onBlur, ...rest }) => {
    const [focused, setFocused] = useState(false);

    const displayValue = focused
        ? value === "" || value === null || value === undefined
            ? ""
            : `$${value}`
        : formatDisplay(value);

    return (
        <TextInput
            {...rest}
            value={displayValue}
            onChange={(e) => onChange(e.target.value.replace(/[^0-9.]/g, ""))}
            onFocus={(e) => {
                setFocused(true);
                rest.onFocus?.(e);
            }}
            onBlur={(e) => {
                setFocused(false);
                onBlur?.(e);
            }}
        />
    );
};

export { CurrencyInput };
